import { BCDataGrid, BCExtremeGridEntities, findMessage } from '@bimser/components';
import { DmObjectType } from '../../entities/DmObjectType';

export const dataTypes = (dataType: string) => {
	switch (dataType) {
		case 'number':
		case 'boolean':
		case 'date':
		case 'datetime':
			return dataType;
		case 'datetimeOffset':
			return 'datetime';
		default:
			return 'string';
	}
};

export const dbTypes = (dataType: string) => {
	switch (dataType) {
		case 'number':
			return BCExtremeGridEntities.ItemType.Decimal;
		case 'boolean':
			return BCExtremeGridEntities.ItemType.Boolean;
		case 'date':
			return BCExtremeGridEntities.ItemType.DateTime;
		case 'datetime':
			return BCExtremeGridEntities.ItemType.DateTimeOffset;
		case 'string':
		default:
			return BCExtremeGridEntities.ItemType.String;
	}
};

export const defaultFilterOperations = (dataTypes: string) => {
	if (dataTypes == 'number') {
		return BCDataGrid.Helpers.DefaultFilterOperations.NumericFilterOperations;
	}
};

export const dataGridIdFromSceneId = (sceneId: string): BCDataGrid.Entities.DataGrids => {
	switch (sceneId) {
		case '#Root':
			return BCDataGrid.Entities.DataGrids.DMRepositories;
		case '#Trash':
			return BCDataGrid.Entities.DataGrids.DMTrash;
		case '#Fav':
			return BCDataGrid.Entities.DataGrids.DMFavorites;
		case '#Recent':
			return BCDataGrid.Entities.DataGrids.DMRecent;
		case '#Search':
			return BCDataGrid.Entities.DataGrids.DMSearch;
		default:
			return BCDataGrid.Entities.DataGrids.DMExplorer;
	}
};

export const getDmObjectTypeAsString = (objectType: DmObjectType) => {
	switch (objectType) {
		case DmObjectType.Repository:
			return findMessage.get('100855');
		case DmObjectType.Folder:
			return findMessage.get('100030');
		case DmObjectType.File:
			return findMessage.get('100005');
		case DmObjectType.Shortcut:
			return findMessage.get('101201');
		case DmObjectType.Content:
			return findMessage.get('100255');
		default:
			return '';
	}
};
